/*
 * API
 * 项目不用分运行环境，所以oDomains里也不用分环境
 * */
/* eslint-disable */
const oDomains = {
  base: "PORTAL_VERSION_API_HOST",
  resource: "RESOURCE_URL", //三个课堂
  service: "SERVICE_API_URL",
  portalVersion: "PORTAL_VERSION_API_HOST",
  portal: "PORTAL_API_HOST",
  console_url: "CONSOLE_URL",
  portalapi: "PORTAL_API_HOST",
  storage: "STORAGE_API_URL",
  rd:"RD",
  log:"LOG_API_URL",
};

const httpAddress = {
  base: "https://openapi-test.talkedu.cn:3443/",
  rd:'/service-rd/v1',
  resource:ENV_API.RESOURCE_URL,
  service: "/service",
  portal: "/api/portal",
  portalVersion: "/api/portal/v1",
  portalapi: "/portalapi",
  storage: "/storage",
  log:"/log",
};

let ENV_DEV_API = process.env.VUE_APP_API;
if (!ENV_DEV_API) {
  ENV_DEV_API = "dev";
}
console.log('ENV_DEV_API', ENV_DEV_API, process)
// ajax default
let ajaxCtx = {};
for (let _key in oDomains) {
  let curHttp = "";
  if (httpAddress[_key] && ENV_DEV_API === "dev") {
    curHttp = httpAddress[_key];
  } else {
    curHttp = window.ENV_API[oDomains[_key]];
  }
  ajaxCtx[_key] = curHttp;
}
// console.table('基本配置', ajaxCtx)
export { ajaxCtx };

// 自定义接口调用超时时间
export const onlineOutTime = 30 * 60 * 1000;
